const classNames = (...classes: any) => classes.filter(Boolean).join(" ");

export default classNames;
